import { render, staticRenderFns } from "./Vocational.vue?vue&type=template&id=3dd37dff&scoped=true"
import script from "./Vocational.vue?vue&type=script&lang=js"
export * from "./Vocational.vue?vue&type=script&lang=js"
import style0 from "./Vocational.vue?vue&type=style&index=0&id=3dd37dff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd37dff",
  null
  
)

export default component.exports